export function serviceAnalytics(state = [], action) {
  switch (action.type) {
    case "SERVICE_ANALYTICS_FETCH_DATA_SUCCESS":
      return action.serviceAnalytics;
    default:
      return state;
  }
}
